import { atom } from "jotai";
import type {
  AgentWorkloadSummaryDto,
  AgentEntityFilingDto,
  AgentActionQueueItemDto,
  AgentEntityFilingHistoryDto,
  AgentFilingStatus,
} from "@/api/workloadApi";

export interface WorkloadFilters {
  regime: string[];
  period: number | null;
  status: AgentFilingStatus[];
}

export const workloadSummaryAtom = atom<AgentWorkloadSummaryDto | null>(null);
workloadSummaryAtom.debugLabel = "workloadSummaryAtom";

export const workloadEntitiesAtom = atom<AgentEntityFilingDto[]>([]);
workloadEntitiesAtom.debugLabel = "workloadEntitiesAtom";

export const actionQueueAtom = atom<AgentActionQueueItemDto[]>([]);
actionQueueAtom.debugLabel = "actionQueueAtom";

export const entityFilingsAtom = atom<AgentEntityFilingHistoryDto[]>([]);
entityFilingsAtom.debugLabel = "entityFilingsAtom";

export const workloadFiltersAtom = atom<WorkloadFilters>({
  regime: [],
  period: null,
  status: [],
});
workloadFiltersAtom.debugLabel = "workloadFiltersAtom";

export const selectedWorkloadEntityIdAtom = atom<string | null>(null);
selectedWorkloadEntityIdAtom.debugLabel = "selectedWorkloadEntityIdAtom";

export const filteredWorkloadEntitiesAtom = atom<AgentEntityFilingDto[]>((get) => {
  const entities = get(workloadEntitiesAtom);
  const filters = get(workloadFiltersAtom);

  let filtered = entities;

  if (filters.regime.length > 0) {
    filtered = filtered.filter((e) => filters.regime.includes(e.regime));
  }

  if (filters.status.length > 0) {
    filtered = filtered.filter((e) => filters.status.includes(e.latestFilingStatus));
  }

  if (filters.period != null) {
    filtered = filtered.filter((e) => {
      if (!e.nextDeadline) return false;
      return new Date(e.nextDeadline).getFullYear() === filters.period;
    });
  }

  return filtered.slice().sort((a, b) => {
    if (!a.nextDeadline && !b.nextDeadline) return 0;
    if (!a.nextDeadline) return 1;
    if (!b.nextDeadline) return -1;
    return new Date(a.nextDeadline).getTime() - new Date(b.nextDeadline).getTime();
  });
});
filteredWorkloadEntitiesAtom.debugLabel = "filteredWorkloadEntitiesAtom";
